const LOGOUT_REQUESTED = "EVT_APP_LOGOUT_REQUESTED";
const LOGIN_REQUESTED = "EVT_APP_LOGIN_REQUESTED";
const PROFILE_REQUESTED = "EVT_APP_PROFILE_REQUESTED";
const PROFILE_RECEIVED = "EVT_APP_PROFILE_RECEIVED";
const PROFILE_FETCH_FAILED = "EVT_APP_PROFILE_FETCH_FAILED";
const TOKEN_RECEIVED_FROM_URL = "EVT_APP_TOKEN_RECEIVED_FROM_URL";

const simpleEvent = type => {
    const evt = {type};
    return () => evt;
};

const createTokenReceivedFromUrl = apiToken => ({type: TOKEN_RECEIVED_FROM_URL, apiToken});

const createLogoutRequested = simpleEvent(LOGOUT_REQUESTED);
const createLoginRequested = simpleEvent(LOGIN_REQUESTED);

const createProfileRequested = simpleEvent(PROFILE_REQUESTED);
const createProfileReceived = (profile) => ({type: PROFILE_RECEIVED, profile});
const createProfileFetchFailed = simpleEvent(PROFILE_FETCH_FAILED);


const update = (model, event) => {
    const current = model || {};
    const type = (event || {}).type;

    if (type === LOGOUT_REQUESTED) {
        const {AcC_userProfile, AcC_abilities, AcC_approvals, AcC_apiToken, AcC_userId, ...next} = current;
        return next;
    }

    if (type === LOGIN_REQUESTED) {
        return {...current, AcC_loginRequested: true};
    }


    if (type === TOKEN_RECEIVED_FROM_URL) {
        const tok = unpackJwt (event.apiToken);
        const userId = tok ? tok.userId : null;
        return {...current, AcC_apiToken: event.apiToken, AcC_userId: userId };
    }

    if (type === PROFILE_REQUESTED) {
        return { ...current, AcC_profileRequested: true }
    }

    if (type === PROFILE_RECEIVED) {
        return { ...current, AcC_profileRequested: false, AcC_userProfile: event.profile }
    }

    if (type === PROFILE_FETCH_FAILED) {
        const {AcC_userProfile, AcC_profileRequested, ...next} = current;
        return next;
    }

    return current;
};


const apiTokenOf = state => (state && state.AcC_apiToken) || "";
const userIdOf = state => (state && state.AcC_userId) || "";
const profileRequestedOf = state => !!state && !!state.AcC_profileRequested;
const userProfileOf = state => (state && state.AcC_userProfile) || ({});
const loginRequestedOf = state => !!state && !!state.AcC_loginRequested;
const loggedInOf = state => !!state && !!state.AcC_userId;

const decodeBase64 = str => {
    var output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
        case 0:
            break;
        case 2:
            output += '==';
            break;
        case 3:
            output += '=';
            break;
        default:
            return null;
    }
    return window.atob(output);
};

const unpackJwt = tok => {
    const parts = tok.split('.');
    try {
        return JSON.parse(decodeBase64(parts[1]))
    } catch (x) {
        return null;
    }
};


// exported for interop, not intended for view
// maybe I should make them their own module, not sure
// or maybe they should be defined in interop ????
// this is all kind of prototype-y until I get my head
// around how i want do to effectful things
const eventTypes = {
    LOGOUT_REQUESTED,
    LOGIN_REQUESTED,
    TOKEN_RECEIVED_FROM_URL,
    PROFILE_REQUESTED,
    PROFILE_RECEIVED,
    PROFILE_FETCH_FAILED
};

export {
    createLogoutRequested,
    createLoginRequested,
    createTokenReceivedFromUrl,
    createProfileRequested,
    createProfileReceived,
    createProfileFetchFailed,
    update,
    eventTypes,
    apiTokenOf,
    userIdOf,
    profileRequestedOf,
    userProfileOf,
    loginRequestedOf,
    loggedInOf
}



// WEBPACK FOOTER //
// ./src/user/model.js